
export function stopEventsPropagation(node: HTMLElement, eventTypes: string[]) {

    const handler = (event: Event) => {
        event.stopPropagation();
    };

    eventTypes.forEach((type) => {
        node.addEventListener(type, handler);
    });

    return {
        destroy() {
            eventTypes.forEach((type) => {
                node.removeEventListener(type, handler);
            });
        }
    };
}